import React, { useState, useEffect } from 'react';
import { cloneDeep, filter } from 'lodash';
import { ToastContainer } from 'react-toastify';
import { Card, CardBody, Container } from 'reactstrap';

import ErrorBoundary from 'components/ErrorBoundary';
import SearchContainer from './SearchContainer';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import SbDetailsTable from './SbReportsTables/SbDetailsTable';
import SbSummaryTable from './SbReportsTables/SbSummaryTable';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';

let filers = [];
let detailFilter = [];
let unmappedchargecode=[
    {
        "claimID": 13727987,
        "drugUtilizationID": 18276259,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564545",
        "visitNumber": "6465453205",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677885",
        "chargeDescription": "test5",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor3",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776784,
        "drugUtilizationID": 2097373,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38806",
        "visitNumber": "RT885806",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44006",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349828510",
        "drugName": "DOCUSATE CALCIUM 240 MG CAP",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": 12,
        "quantity": 0.08333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776975,
        "drugUtilizationID": 2097564,
        "drugAdminDate": "2025-01-23T10:02:02",
        "mrNumber": "RN3880003",
        "visitNumber": "ST8858003",
        "patientType": "P3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "83658",
        "chargeDescription": "Test03",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776981,
        "drugUtilizationID": 2097570,
        "drugAdminDate": "2025-02-12T10:02:02",
        "mrNumber": "RN3880003",
        "visitNumber": "ST8858003",
        "patientType": "P3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test03",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776983,
        "drugUtilizationID": 2097572,
        "drugAdminDate": "2025-02-14T10:02:02",
        "mrNumber": "RN3880005",
        "visitNumber": "ST8858005",
        "patientType": "P5",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test05",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349831224",
        "drugName": "MULTI-TREX TABLET",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L5",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": 5,
        "quantity": 0.2,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776984,
        "drugUtilizationID": 2097573,
        "drugAdminDate": "2025-02-10T10:02:02",
        "mrNumber": "RN3880006",
        "visitNumber": "ST8858006",
        "patientType": "P6",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test06",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L6",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776982,
        "drugUtilizationID": 2097571,
        "drugAdminDate": "2025-02-13T10:02:02",
        "mrNumber": "RN3880004",
        "visitNumber": "ST8858004",
        "patientType": "P4",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test04",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L4",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776980,
        "drugUtilizationID": 2097569,
        "drugAdminDate": "2025-02-10T10:02:02",
        "mrNumber": "RN3880002",
        "visitNumber": "ST8858002",
        "patientType": "P2",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test02",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L2",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776979,
        "drugUtilizationID": 2097568,
        "drugAdminDate": "2025-02-10T10:02:02",
        "mrNumber": "RN3880001",
        "visitNumber": "ST8858001",
        "patientType": "P1",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test01",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L1",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776802,
        "drugUtilizationID": 2097391,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38824",
        "visitNumber": "RT885824",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44024",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "08137302700",
        "drugName": "DISPOS-A-GLOVE EXAMINATION",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": 7,
        "quantity": 0.14286,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776977,
        "drugUtilizationID": 2097566,
        "drugAdminDate": "2025-01-23T10:02:02",
        "mrNumber": "RN3880005",
        "visitNumber": "ST8858005",
        "patientType": "P5",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "83660",
        "chargeDescription": "Test05",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00053765602",
        "drugName": "MONOCLATE-P 500AHFU KIT",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L5",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": 6,
        "quantity": 0.16667,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776800,
        "drugUtilizationID": 2097389,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38822",
        "visitNumber": "RT885822",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44022",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00169815001",
        "drugName": "ESPEROCT 1,500 UNIT VIAL",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": 6,
        "quantity": 0.16667,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776973,
        "drugUtilizationID": 2097562,
        "drugAdminDate": "2025-01-23T10:02:02",
        "mrNumber": "RN3880001",
        "visitNumber": "ST8858001",
        "patientType": "P1",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "83656",
        "chargeDescription": "Test01",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00000000133",
        "drugName": "test",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L1",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": 3,
        "quantity": 0.33333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 13727985,
        "drugUtilizationID": 18276257,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564543",
        "visitNumber": "6465453203",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677883",
        "chargeDescription": "test3",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor2",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 13727984,
        "drugUtilizationID": 18276256,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564542",
        "visitNumber": "6465453202",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677882",
        "chargeDescription": "test2",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor2",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Provider Not Included",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },

]
let locationpending=[
    {
        "claimID": 13727987,
        "drugUtilizationID": 18276259,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564545",
        "visitNumber": "6465453205",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677885",
        "chargeDescription": "test5",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor3",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776784,
        "drugUtilizationID": 2097373,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38806",
        "visitNumber": "RT885806",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44006",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349828510",
        "drugName": "DOCUSATE CALCIUM 240 MG CAP",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": 12,
        "quantity": 0.08333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776975,
        "drugUtilizationID": 2097564,
        "drugAdminDate": "2025-01-23T10:02:02",
        "mrNumber": "RN3880003",
        "visitNumber": "ST8858003",
        "patientType": "P3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "83658",
        "chargeDescription": "Test03",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776981,
        "drugUtilizationID": 2097570,
        "drugAdminDate": "2025-02-12T10:02:02",
        "mrNumber": "RN3880003",
        "visitNumber": "ST8858003",
        "patientType": "P3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test03",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776983,
        "drugUtilizationID": 2097572,
        "drugAdminDate": "2025-02-14T10:02:02",
        "mrNumber": "RN3880005",
        "visitNumber": "ST8858005",
        "patientType": "P5",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test05",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349831224",
        "drugName": "MULTI-TREX TABLET",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L5",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": 5,
        "quantity": 0.2,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776984,
        "drugUtilizationID": 2097573,
        "drugAdminDate": "2025-02-10T10:02:02",
        "mrNumber": "RN3880006",
        "visitNumber": "ST8858006",
        "patientType": "P6",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test06",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L6",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776982,
        "drugUtilizationID": 2097571,
        "drugAdminDate": "2025-02-13T10:02:02",
        "mrNumber": "RN3880004",
        "visitNumber": "ST8858004",
        "patientType": "P4",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test04",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L4",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776980,
        "drugUtilizationID": 2097569,
        "drugAdminDate": "2025-02-10T10:02:02",
        "mrNumber": "RN3880002",
        "visitNumber": "ST8858002",
        "patientType": "P2",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test02",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L2",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776979,
        "drugUtilizationID": 2097568,
        "drugAdminDate": "2025-02-10T10:02:02",
        "mrNumber": "RN3880001",
        "visitNumber": "ST8858001",
        "patientType": "P1",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test01",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L1",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776802,
        "drugUtilizationID": 2097391,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38824",
        "visitNumber": "RT885824",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44024",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "08137302700",
        "drugName": "DISPOS-A-GLOVE EXAMINATION",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": 7,
        "quantity": 0.14286,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776977,
        "drugUtilizationID": 2097566,
        "drugAdminDate": "2025-01-23T10:02:02",
        "mrNumber": "RN3880005",
        "visitNumber": "ST8858005",
        "patientType": "P5",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "83660",
        "chargeDescription": "Test05",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00053765602",
        "drugName": "MONOCLATE-P 500AHFU KIT",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L5",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": 6,
        "quantity": 0.16667,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776800,
        "drugUtilizationID": 2097389,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38822",
        "visitNumber": "RT885822",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44022",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00169815001",
        "drugName": "ESPEROCT 1,500 UNIT VIAL",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": 6,
        "quantity": 0.16667,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776973,
        "drugUtilizationID": 2097562,
        "drugAdminDate": "2025-01-23T10:02:02",
        "mrNumber": "RN3880001",
        "visitNumber": "ST8858001",
        "patientType": "P1",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "83656",
        "chargeDescription": "Test01",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00000000133",
        "drugName": "test",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L1",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": 3,
        "quantity": 0.33333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 13727985,
        "drugUtilizationID": 18276257,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564543",
        "visitNumber": "6465453203",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677883",
        "chargeDescription": "test3",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor2",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 13727984,
        "drugUtilizationID": 18276256,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564542",
        "visitNumber": "6465453202",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677882",
        "chargeDescription": "test2",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor2",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Invalid Effective Date",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },

]
let patientpending=[
    {
        "claimID": 13727987,
        "drugUtilizationID": 18276259,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564545",
        "visitNumber": "6465453205",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677885",
        "chargeDescription": "test5",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor3",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776784,
        "drugUtilizationID": 2097373,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38806",
        "visitNumber": "RT885806",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44006",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349828510",
        "drugName": "DOCUSATE CALCIUM 240 MG CAP",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": 12,
        "quantity": 0.08333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776975,
        "drugUtilizationID": 2097564,
        "drugAdminDate": "2025-01-23T10:02:02",
        "mrNumber": "RN3880003",
        "visitNumber": "ST8858003",
        "patientType": "P3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "83658",
        "chargeDescription": "Test03",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776981,
        "drugUtilizationID": 2097570,
        "drugAdminDate": "2025-02-12T10:02:02",
        "mrNumber": "RN3880003",
        "visitNumber": "ST8858003",
        "patientType": "P3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test03",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776983,
        "drugUtilizationID": 2097572,
        "drugAdminDate": "2025-02-14T10:02:02",
        "mrNumber": "RN3880005",
        "visitNumber": "ST8858005",
        "patientType": "P5",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test05",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349831224",
        "drugName": "MULTI-TREX TABLET",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L5",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": 5,
        "quantity": 0.2,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776984,
        "drugUtilizationID": 2097573,
        "drugAdminDate": "2025-02-10T10:02:02",
        "mrNumber": "RN3880006",
        "visitNumber": "ST8858006",
        "patientType": "P6",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test06",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L6",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776982,
        "drugUtilizationID": 2097571,
        "drugAdminDate": "2025-02-13T10:02:02",
        "mrNumber": "RN3880004",
        "visitNumber": "ST8858004",
        "patientType": "P4",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test04",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L4",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776980,
        "drugUtilizationID": 2097569,
        "drugAdminDate": "2025-02-10T10:02:02",
        "mrNumber": "RN3880002",
        "visitNumber": "ST8858002",
        "patientType": "P2",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test02",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L2",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776979,
        "drugUtilizationID": 2097568,
        "drugAdminDate": "2025-02-10T10:02:02",
        "mrNumber": "RN3880001",
        "visitNumber": "ST8858001",
        "patientType": "P1",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "8001",
        "chargeDescription": "Test01",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L1",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776802,
        "drugUtilizationID": 2097391,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38824",
        "visitNumber": "RT885824",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44024",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "08137302700",
        "drugName": "DISPOS-A-GLOVE EXAMINATION",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": 7,
        "quantity": 0.14286,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776977,
        "drugUtilizationID": 2097566,
        "drugAdminDate": "2025-01-23T10:02:02",
        "mrNumber": "RN3880005",
        "visitNumber": "ST8858005",
        "patientType": "P5",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "83660",
        "chargeDescription": "Test05",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00053765602",
        "drugName": "MONOCLATE-P 500AHFU KIT",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L5",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": 6,
        "quantity": 0.16667,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776800,
        "drugUtilizationID": 2097389,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38822",
        "visitNumber": "RT885822",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44022",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00169815001",
        "drugName": "ESPEROCT 1,500 UNIT VIAL",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": 6,
        "quantity": 0.16667,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776973,
        "drugUtilizationID": 2097562,
        "drugAdminDate": "2025-01-23T10:02:02",
        "mrNumber": "RN3880001",
        "visitNumber": "ST8858001",
        "patientType": "P1",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "83656",
        "chargeDescription": "Test01",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor 1",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": null,
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00000000133",
        "drugName": "test",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "L1",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": 3,
        "quantity": 0.33333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 13727985,
        "drugUtilizationID": 18276257,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564543",
        "visitNumber": "6465453203",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677883",
        "chargeDescription": "test3",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor2",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 13727984,
        "drugUtilizationID": 18276256,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564542",
        "visitNumber": "6465453202",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677882",
        "chargeDescription": "test2",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor2",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },

]
let hiddencharge=[
    {
        "claimID": 13727987,
        "drugUtilizationID": 18276259,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564545",
        "visitNumber": "6465453205",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677885",
        "chargeDescription": "test5",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor3",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Hidden Charge Code",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776784,
        "drugUtilizationID": 2097373,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38806",
        "visitNumber": "RT885806",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44006",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349828510",
        "drugName": "DOCUSATE CALCIUM 240 MG CAP",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Hidden Charge Code",
        "claimProcessedDate": null,
        "bupp": 12,
        "quantity": 0.08333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
]
let drugadministration=[
    {
        "claimID": 13727987,
        "drugUtilizationID": 18276259,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564545",
        "visitNumber": "6465453205",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677885",
        "chargeDescription": "test5",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor3",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Drug Administration Date Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776784,
        "drugUtilizationID": 2097373,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38806",
        "visitNumber": "RT885806",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44006",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349828510",
        "drugName": "DOCUSATE CALCIUM 240 MG CAP",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Drug Administration Date Not Correct Format",
        "claimProcessedDate": null,
        "bupp": 12,
        "quantity": 0.08333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
]
let dispensingqty=[
    {
        "claimID": 13727987,
        "drugUtilizationID": 18276259,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564545",
        "visitNumber": "6465453205",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677885",
        "chargeDescription": "test5",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor3",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776784,
        "drugUtilizationID": 2097373,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38806",
        "visitNumber": "RT885806",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44006",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349828510",
        "drugName": "DOCUSATE CALCIUM 240 MG CAP",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "Dispensing Quantity Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": 12,
        "quantity": 0.08333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
]
let grosscharge=[
    {
        "claimID": 13727987,
        "drugUtilizationID": 18276259,
        "drugAdminDate": "2024-11-20T10:02:02",
        "mrNumber": "7576564545",
        "visitNumber": "6465453205",
        "patientType": "Patient3",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "965677885",
        "chargeDescription": "test5",
        "dispensedQuantity": 100,
        "grossCharge": 5,
        "primaryPayor": "Payor3",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_testutil32.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": null,
        "drugName": null,
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "Location3",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "GrossCharge is Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": null,
        "quantity": null,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
    {
        "claimID": 14776784,
        "drugUtilizationID": 2097373,
        "drugAdminDate": "2024-10-11T10:02:02",
        "mrNumber": "RN38806",
        "visitNumber": "RT885806",
        "patientType": "patient11",
        "isInPatient": null,
        "location": null,
        "isMixedUseArea": null,
        "chargeCode": "44006",
        "chargeDescription": "Test5",
        "dispensedQuantity": 1,
        "grossCharge": 5,
        "primaryPayor": "Payor6",
        "secondaryPayor": "TEST",
        "tertiaryPayor": "TEST",
        "facility": "TEST",
        "hcpcsjcode": "857907456",
        "transactionID": "564",
        "providerNPI": "",
        "providerName": null,
        "fileProcessName": "SB_Util_1127.csv",
        "fileProcessID": 0,
        "ceid": null,
        "ceName": "Coveredentity1",
        "accumulatorID": null,
        "accumulatorName": "Accumulator",
        "drugID": null,
        "ndc": "00349828510",
        "drugName": "DOCUSATE CALCIUM 240 MG CAP",
        "orphanDrugFlag": "N",
        "drugExclusionReason": null,
        "accountTypeID": null,
        "accountType": null,
        "patientTypeID": null,
        "patientTypeDesc": null,
        "serviceLocationID": null,
        "serviceLocationDesc": "location11",
        "chargeID": null,
        "chargeDrugID": null,
        "payorTypeID": null,
        "claimReason": "GrossCharge is Missing OR Not Correct Format",
        "claimProcessedDate": null,
        "bupp": 12,
        "quantity": 0.08333,
        "accumulation": null,
        "claimReferenceID": null,
        "comments": null,
        "usedHL7": "N",
        "hL7ID": null,
        "admitDate": null,
        "dischargeDate": null,
        "processedFlag": null,
        "reprocessFlag": null,
        "inactiveFlag": null,
        "createdByID": 0,
        "createdDate": "0001-01-01T00:00:00",
        "modifiedByID": 0,
        "modifiedDate": "0001-01-01T00:00:00",
        "primaryPayorDesc": null,
        "secondaryPayorDesc": null,
        "tertiaryPayorDesc": null
    },
]
let pharmaOrders = [
    {
      accountType: "WAC",
      wholesaler: "Mckesson",
      poNumber: 65335,
      sourcePoNumber: "MEDSHELF08",
      poType: "Split",
      purchaseDate: "2/15/2024",
      accountNumber: 200200,
      poItemNumber: 105255,
      ndc: 67457067502,
      drugName: "MIACALCIN 400 UNIT/2 ML VIAL",
      invoiceNumber: 7477930068,
      invoicedDate: "2/16/2024",
      packages: 13,
      price: 2904.4,
      totalSpend: 37757.2,
      price340BPerPack: 0.02,
      totalSpend340B: 0.26,
      priceGPOPerPack: 1056.94,
      totalSpendGPO: 13740.22,
      priceWACPerPack: 2904.4,
      totalSpendWAC: 37757.2,
      savings340BPerPack: null,
      totalSavings340B: null,
      wacImpact: -24016.98
    },
    {
      accountType: "WAC",
      wholesaler: "Mckesson",
      poNumber: 6615,
      sourcePoNumber: "42341_CSV13",
      poType: "Non Split",
      purchaseDate: "7/06/2023",
      accountNumber: 200200,
      poItemNumber: 35129,
      ndc: "00409909461",
      drugName: "FENTANYL 2,500 MCG/50 ML VIAL",
      invoiceNumber: 7430307085,
      invoicedDate: "7/11/2023",
      packages: 50,
      price: 485.37,
      totalSpend: 24268.5,
      price340BPerPack: 286.45,
      totalSpend340B: 14322.5,
      priceGPOPerPack: 93.08,
      totalSpendGPO: 4654,
      priceWACPerPack: 485.37,
      totalSpendWAC: 24268.5,
      savings340BPerPack: null,
      totalSavings340B: null,
      wacImpact: -19614.5
    },
    {
      accountType: "WAC",
      wholesaler: "Mckesson",
      poNumber: 87015,
      sourcePoNumber: "IV",
      poType: "Non Split",
      purchaseDate: "1/29/2025",
      accountNumber: 200200,
      poItemNumber: 231510,
      ndc: 63323059613,
      drugName: "GLUCAGON 1 MG VIAL",
      invoiceNumber: 7547851298,
      invoicedDate: "1/29/2025",
      packages: 20,
      price: 2046.4,
      totalSpend: 40928,
      price340BPerPack: 811.32,
      totalSpend340B: 16226.4,
      priceGPOPerPack: 1138.98,
      totalSpendGPO: 22779.6,
      priceWACPerPack: 2046.4,
      totalSpendWAC: 40928,
      savings340BPerPack: null,
      totalSavings340B: null,
      wacImpact: -18148.4
    },
    {
      accountType: "WAC",
      wholesaler: "Mckesson",
      poNumber: 70749,
      sourcePoNumber: "MEDSHELF22",
      poType: "Split",
      purchaseDate: "5/09/2024",
      accountNumber: 200200,
      poItemNumber: 137792,
      ndc: 67457067502,
      drugName: "MIACALCIN 400 UNIT/2 ML VIAL",
      invoiceNumber: 7495745246,
      invoicedDate: "5/10/2024",
      packages: 9,
      price: 2904.4,
      totalSpend: 26139.6,
      price340BPerPack: 0.02,
      totalSpend340B: 0.18,
      priceGPOPerPack: 1056.94,
      totalSpendGPO: 9512.46,
      priceWACPerPack: 2904.4,
      totalSpendWAC: 26139.6,
      savings340BPerPack: null,
      totalSavings340B: null,
      wacImpact: -16627.14
    },
    {
      accountType: "WAC",
      wholesaler: "Mckesson",
      poNumber: 61402,
      sourcePoNumber: "ELLIS AIU RXAH",
      poType: "Split",
      purchaseDate: "12/14/2023",
      accountNumber: 200200,
      poItemNumber: 82249,
      ndc: "00517234025",
      drugName: "VENOFER 100 MG/5 ML VIAL",
      invoiceNumber: 7464548897,
      invoicedDate: "12/15/2023",
      packages: 25,
      price: 1419.23,
      totalSpend: 35480.75,
      price340BPerPack: 621.88,
      totalSpend340B: 15547,
      priceGPOPerPack: 823.09,
      totalSpendGPO: 20577.25,
      priceWACPerPack: 1419.23,
      totalSpendWAC: 35480.75,
      savings340BPerPack: null,
      totalSavings340B: null,
      wacImpact: -14903.5
    },
        {
          accountType: "WAC",
          wholesaler: "Mckesson",
          poNumber: 61412,
          sourcePoNumber: "MEDSHELF52",
          poType: "Split",
          purchaseDate: "12/14/2023",
          accountNumber: 200200,
          poItemNumber: 82429,
          ndc: 67457067502,
          drugName: "MIACALCIN 400 UNIT/2 ML VIAL",
          invoiceNumber: 7464598293,
          invoicedDate: "12/15/2023",
          packages: 8,
          price: 2904.4,
          totalSpend: 23235.2,
          price340BPerPack: 0.02,
          totalSpend340B: 0.16,
          priceGPOPerPack: 1056.94,
          totalSpendGPO: 8455.52,
          priceWACPerPack: 2904.4,
          totalSpendWAC: 23235.2,
          savings340BPerPack: null,
          totalSavings340B: null,
          wacImpact: -14779.68
        },
        {
          accountType: "WAC",
          wholesaler: "Mckesson",
          poNumber: 92931,
          sourcePoNumber: "ELLIS",
          poType: "Non Split",
          purchaseDate: "4/04/2025",
          accountNumber: 200200,
          poItemNumber: 269624,
          ndc: 63459010450,
          drugName: "TRUXIMA 500 MG/50 ML VIAL",
          invoiceNumber: 7560838770,
          invoicedDate: "4/04/2025",
          packages: 9,
          price: 4079.78,
          totalSpend: 36718.02,
          price340BPerPack: 1042.36,
          totalSpend340B: 9381.24,
          priceGPOPerPack: 2692.66,
          totalSpendGPO: 24233.94,
          priceWACPerPack: 4079.78,
          totalSpendWAC: 36718.02,
          savings340BPerPack: null,
          totalSavings340B: null,
          wacImpact: -12484.08
        },
        {
          accountType: "WAC",
          wholesaler: "Mckesson",
          poNumber: 86935,
          sourcePoNumber: "EMERGENCY",
          poType: "Non Split",
          purchaseDate: "1/28/2025",
          accountNumber: 200200,
          poItemNumber: 231129,
          ndc: 63323059303,
          drugName: "GLUCAGON 1 MG VIAL",
          invoiceNumber: 7547839842,
          invoicedDate: "1/28/2025",
          packages: 100,
          price: 233.29,
          totalSpend: 23329,
          price340BPerPack: 90.24,
          totalSpend340B: 9024,
          priceGPOPerPack: 113.9,
          totalSpendGPO: 11390,
          priceWACPerPack: 233.29,
          totalSpendWAC: 23329,
          savings340BPerPack: null,
          totalSavings340B: null,
          wacImpact: -11939
        },
        {
          accountType: "WAC",
          wholesaler: "Mckesson",
          poNumber: 10919,
          sourcePoNumber: "56745_MED",
          poType: "Non Split",
          purchaseDate: "10/15/2023",
          accountNumber: 200200,
          poItemNumber: 59858,
          ndc: "00407141491",
          drugName: "OMNIPAQUE 350 MG/ML INFU BTL",
          invoiceNumber: 7451501819,
          invoicedDate: "10/16/2023",
          packages: 14,
          price: 927.4,
          totalSpend: 12983.6,
          price340BPerPack: 73.84,
          totalSpend340B: 1033.76,
          priceGPOPerPack: 129.16,
          totalSpendGPO: 1808.24,
          priceWACPerPack: 927.4,
          totalSpendWAC: 12983.6,
          savings340BPerPack: null,
          totalSavings340B: null,
          wacImpact: -11175.36
        },
        {
          accountType: "WAC",
          wholesaler: "Mckesson",
          poNumber: 65804,
          sourcePoNumber: "ELLIS AIU14",
          poType: "Split",
          purchaseDate: "2/22/2024",
          accountNumber: 200200,
          poItemNumber: 107650,
          ndc: 10019095601,
          drugName: "CYCLOPHOSPHAMIDE 1 GM VIAL",
          invoiceNumber: 7479371464,
          invoicedDate: "2/23/2024",
          packages: 15,
          price: 370.92,
          totalSpend: 5563.8,
          price340BPerPack: 732.5,
          totalSpend340B: 10987.5,
          priceGPOPerPack: 805.75,
          totalSpendGPO: 12086.25,
          priceWACPerPack: 805.75,
          totalSpendWAC: 12086.25,
          savings340BPerPack: null,
          totalSavings340B: null,
          wacImpact: 6522.45
        },
        {
          accountType: "WAC",
          wholesaler: "Mckesson",
          poNumber: 67141,
          sourcePoNumber: "ELLIS AIU RXBG",
          poType: "Split",
          purchaseDate: "3/14/2024",
          accountNumber: 200200,
          poItemNumber: 115987,
          ndc: 10019095601,
          drugName: "CYCLOPHOSPHAMIDE 1 GM VIAL",
          invoiceNumber: 7483830701,
          invoicedDate: "3/15/2024",
          packages: 15,
          price: 370.92,
          totalSpend: 5563.8,
          price340BPerPack: 732.5,
          totalSpend340B: 10987.5,
          priceGPOPerPack: 805.75,
          totalSpendGPO: 12086.25,
          priceWACPerPack: 805.75,
          totalSpendWAC: 12086.25,
          savings340BPerPack: null,
          totalSavings340B: null,
          wacImpact: 6522.45
        },
        {
            accountType: "WAC",
            wholesaler: "Mckesson",
            poNumber: 1800,
            sourcePoNumber: "39051_ELLIS",
            poType: "Non Split",
            purchaseDate: "4/27/2023",
            accountNumber: 200200,
            poItemNumber: 8887,
            ndc: "00069080901",
            drugName: "INFLECTRA 100 MG VIAL",
            invoiceNumber: 7414566587,
            invoicedDate: "4/28/2023",
            packages: 34,
            price: 683.57,
            totalSpend: 23241.38,
            price340BPerPack: 133.79,
            totalSpend340B: 4548.86,
            priceGPOPerPack: 878.62,
            totalSpendGPO: 29873.08,
            priceWACPerPack: 684.3,
            totalSpendWAC: 23266.2,
            savings340BPerPack: null,
            totalSavings340B: null,
            wacImpact: 6631.7
          },
          {
            accountType: "WAC",
            wholesaler: "Mckesson",
            poNumber: 63460,
            sourcePoNumber: "ELLIS AIU09",
            poType: "Split",
            purchaseDate: "1/19/2024",
            accountNumber: 200200,
            poItemNumber: 94401,
            ndc: "57970010001",
            drugName: "DALVANCE 500 MG VIAL",
            invoiceNumber: 7472046507,
            invoicedDate: "1/22/2024",
            packages: 8,
            price: 927.3,
            totalSpend: 7418.4,
            price340BPerPack: 1127.83,
            totalSpend340B: 9022.64,
            priceGPOPerPack: 1779.13,
            totalSpendGPO: 14233.04,
            priceWACPerPack: 1779.13,
            totalSpendWAC: 14233.04,
            savings340BPerPack: null,
            totalSavings340B: null,
            wacImpact: 6814.64
          },
          {
            accountType: "WAC",
            wholesaler: "Mckesson",
            poNumber: 83023,
            sourcePoNumber: "H000193578112100",
            poType: "Split",
            purchaseDate: "11/21/2024",
            accountNumber: 200200,
            poItemNumber: 208130,
            ndc: "57970010001",
            drugName: "DALVANCE 500 MG VIAL",
            invoiceNumber: 7534964409,
            invoicedDate: "11/22/2024",
            packages: 9,
            price: 923.3,
            totalSpend: 8309.7,
            price340BPerPack: 1155.93,
            totalSpend340B: 10403.37,
            priceGPOPerPack: 1779.13,
            totalSpendGPO: 16012.17,
            priceWACPerPack: 1779.13,
            totalSpendWAC: 16012.17,
            savings340BPerPack: null,
            totalSavings340B: null,
            wacImpact: 7702.47
          },
          {
            accountType: "WAC",
            wholesaler: "Mckesson",
            poNumber: 83338,
            sourcePoNumber: "MEDCAR 0371",
            poType: "Split",
            purchaseDate: "11/26/2024",
            accountNumber: 200200,
            poItemNumber: 210376,
            ndc: "50242012047",
            drugName: "TNKASE 50 MG KIT",
            invoiceNumber: 7535891346,
            invoicedDate: "11/27/2024",
            packages: 8,
            price: 7553.63,
            totalSpend: 60429.04,
            price340BPerPack: 7827.6,
            totalSpend340B: 62620.8,
            priceGPOPerPack: 8610.36,
            totalSpendGPO: 68882.88,
            priceWACPerPack: 8610.36,
            totalSpendWAC: 68882.88,
            savings340BPerPack: null,
            totalSavings340B: null,
            wacImpact: 8453.84
          },
          {
            accountType: "WAC",
            wholesaler: "Mckesson",
            poNumber: 80516,
            sourcePoNumber: "MEDCAR 0161",
            poType: "Split",
            purchaseDate: "10/16/2024",
            accountNumber: 200200,
            poItemNumber: 194804,
            ndc: "57970010001",
            drugName: "DALVANCE 500 MG VIAL",
            invoiceNumber: 7527727815,
            invoicedDate: "10/17/2024",
            packages: 9,
            price: 927.3,
            totalSpend: 8345.7,
            price340BPerPack: 1957.05,
            totalSpend340B: 17613.45,
            priceGPOPerPack: 1957.05,
            totalSpendGPO: 17613.45,
            priceWACPerPack: 1957.05,
            totalSpendWAC: 17613.45,
            savings340BPerPack: null,
            totalSavings340B: null,
            wacImpact: 9267.75
          },
          {
            accountType: "WAC",
            wholesaler: "Mckesson",
            poNumber: 1496,
            sourcePoNumber: "38888_ELLIS",
            poType: "Non Split",
            purchaseDate: "4/24/2023",
            accountNumber: 200200,
            poItemNumber: 7458,
            ndc: "00069080901",
            drugName: "INFLECTRA 100 MG VIAL",
            invoiceNumber: 7413618875,
            invoicedDate: "4/25/2023",
            packages: 58,
            price: 683.57,
            totalSpend: 39647.06,
            price340BPerPack: 133.79,
            totalSpend340B: 7759.82,
            priceGPOPerPack: 878.62,
            totalSpendGPO: 50959.96,
            priceWACPerPack: 684.3,
            totalSpendWAC: 39689.4,
            savings340BPerPack: null,
            totalSavings340B: null,
            wacImpact: 11312.9
          },
          {
            accountType: "WAC",
            wholesaler: "ABC",
            poNumber: 61115,
            sourcePoNumber: "61115_H000200245",
            poType: "Non Split",
            purchaseDate: "8/24/2023",
            accountNumber: 200200,
            poItemNumber: 81037,
            ndc: "68382039601",
            drugName: "SOD PHENYLACET-SOD BENZOATE VL",
            invoiceNumber: 3144520724,
            invoicedDate: "8/24/2023",
            packages: 2,
            price: 1900,
            totalSpend: 3800,
            price340BPerPack: 2583.24,
            totalSpend340B: 5166.48,
            priceGPOPerPack: 9000,
            totalSpendGPO: 18000,
            priceWACPerPack: 3500,
            totalSpendWAC: 7000,
            savings340BPerPack: null,
            totalSavings340B: null,
            wacImpact: 14200
          },
          {
            accountType: "WAC",
            wholesaler: "Mckesson",
            poNumber: 11847,
            sourcePoNumber: "231225735",
            poType: "Non Split",
            purchaseDate: "7/12/2023",
            accountNumber: 200200,
            poItemNumber: 64450,
            ndc: "00409909461",
            drugName: "FENTANYL 2,500 MCG/50 ML VIAL",
            invoiceNumber: 7451215907,
            invoicedDate: "10/13/2023",
            packages: -37,
            price: 485.37,
            totalSpend: -17958.69,
            price340BPerPack: 286.45,
            totalSpend340B: -10598.65,
            priceGPOPerPack: 93.08,
            totalSpendGPO: -3443.96,
            priceWACPerPack: 485.37,
            totalSpendWAC: -17958.69,
            savings340BPerPack: null,
            totalSavings340B: null,
            wacImpact: 14514.73
          },
          {
            accountType: "WAC",
            wholesaler: "ABC",
            poNumber: 61112,
            sourcePoNumber: "61112_H000200246",
            poType: "Non Split",
            purchaseDate: "8/23/2023",
            accountNumber: 200200,
            poItemNumber: 81028,
            ndc: "68382039601",
            drugName: "SOD PHENYLACET-SOD BENZOATE VL",
            invoiceNumber: 3144520267,
            invoicedDate: "8/23/2023",
            packages: 4,
            price: 1900,
            totalSpend: 7600,
            price340BPerPack: 2583.24,
            totalSpend340B: 10332.96,
            priceGPOPerPack: 9000,
            totalSpendGPO: 36000,
            priceWACPerPack: 3500,
            totalSpendWAC: 14000,
            savings340BPerPack: null,
            totalSavings340B: null,
            wacImpact: 28400
          }
      
      
  ];
 
  let pharmaData = [
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 Curasctipt",
      wholesaler: "CuraScript",
      accountType: "WAC",
      accountNumber: 369852,
      totalSpend: "$26,360.58",
      totalSavings340B: "$0.00",
      wacImpact:"$574.64",
      netSavings:"$574.64"
    },
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 McKesson",
      wholesaler: "Mckesson",
      accountType: "WAC",
      accountNumber: 123654,
      totalSpend: "$3,448,342.98 ",
      totalSavings340B: "$0.00",
      wacImpact:'$471,772.05',
      netSavings:'$471,772.05'
    },
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 McKesson",
      wholesaler: "Mckesson",
      accountType: "WAC",
      accountNumber: 987485,
      totalSpend: "$1,559,355.78 ",
      totalSavings340B: "$0.00",
      wacImpact: "$189,316.71",
      netSavings: "$189,316.71"
    },
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 McKesson",
      wholesaler: "Mckesson",
      accountType: "WAC",
      accountNumber: 258258,
      totalSpend: "$1,101,449.76 ",
      totalSavings340B: "$0.00",
      wacImpact: "$206,293.45",
      netSavings: "$206,293.45"
    },
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 McKesson",
      wholesaler: "Mckesson",
      accountType: "WAC",
      accountNumber: 369369,
      totalSpend:"$374,121.47 ",
      totalSavings340B: "$0.00",
      wacImpact: "$35,999.30",
      netSavings: "$35,999.30"
    },
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 McKesson",
      wholesaler: "Mckesson",
      accountType: "WAC",
      accountNumber: 147147,
      totalSpend: "$2,222,238.31 ",
      totalSavings340B: "$0.00",
      wacImpact: "$122,615.97",
      netSavings: "$122,615.97"
    },
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 ABC",
      wholesaler: "ABC",
      accountType: "WAC",
      accountNumber: 100100100,
      totalSpend: "$2,125,353.87 ",
      totalSavings340B: "$0.00",
      wacImpact:"$110,083.33",
      netSavings:"$110,083.33"
    },
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 McKEsson",
      wholesaler: "Mckesson",
      accountType: "WAC",
      accountNumber: 369369,
      totalSpend: "$20,505,589.72 ",
      totalSavings340B: "$0.00",
      wacImpact:"$2,719,754.21",
      netSavings:"$2,719,754.21"
    },
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 ABC",
      wholesaler: "ABC",
      accountType: "WAC",
      accountNumber: 100100100,
      totalSpend: "$94,684.67 ",
      totalSavings340B: "$0.00",
      wacImpact: "$6,818.53 ",
      netSavings: "$6,818.53 "
    },
    {
      coveredEntity: "PharmaForce DSH 1",
      accumulator: "PharmaForce DSH 1",
      hospitalName: "PharmaForce DSH 1 McKesson",
      wholesaler: "Mckesson",
      accountType: "WAC",
      accountNumber: 258258,
      totalSpend: "$1,092,078.25 ",
      totalSavings340B: "$0.00",
      wacImpact:"$210,374.07",
      netSavings:"$210,374.07"
    }
  ];
// let unmappedchargecode=[]
const SbReports = (props) => {
    const { module, orgId } = props;
    const [collapseSider, setcollapseSider] = useState(false);
    const [key, setKey] = useState('SbSummary');
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [summeryData, setSummeryData] = useState([]);
    const [detailsData, setDetailsData] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [reportType, setReportType] = useState('');
    const [columnFilters, setColumnFilters] = useState([]);
    const [rowdata, setRowdata] = useState();
    const [fullRowdata, setfullRowdata] = useState();
    
    const[unmappeddata,setunmappeddata]=useState(unmappedchargecode)
    const [resetFilterFlag, SetResetFilterFlag]= useState(false);
    const API = useAxios();
    const {
        states: { sbreports },
        setStates,
    } = useContextService();
    const { search, pharmacy, searchTerms, } = sbreports;
    const updateStates = (sbreports) => {
        setStates('sbreports', sbreports);
    };
    const toggleSider = () => {
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        }
        else {
            setCollIcon(faAngleUp);
        }
    }

    useEffect(()=>{
        setDetailsData([])
        setSummeryData([])
    },[orgId])

    const onKeyChange = (k) => {
        setKey(k)
        setRowdata("");
        setfullRowdata({});
        handleTabChange(k);
        sbreports.search.pageSize = 10;
        SetResetFilterFlag(true);
    }
    const onreset = (hastrue) => {
        debugger
        if (hastrue) {
            setSummeryData([]);
            setDetailsData([]);
            pharmaData=[]
            pharmaOrders=[]
            setKey('SbSummary');
            SetResetFilterFlag(true);
            //sbreports.search.pageSize = 10;
        }
    }
    const handleTabChange = async (value) => {
        debugger;
        setKey(value);
        let row = null;
        let acids = [];
        let ceids = [];
        let fltr = {};
        for (var x in searchTerms.accumulationIDs) {
            var rw = searchTerms.accumulationIDs[x];
            acids.push(rw.value);
        }
        for (var x in searchTerms.coveredEntityIDs) {
            var rw = searchTerms.coveredEntityIDs[x];
            ceids.push(rw.value);
        }
        fltr.accumulationIDs = acids;
        fltr.coveredEntityIDs = ceids;
        fltr.startDate = searchTerms.startDate;
        fltr.dateRangeID = searchTerms.dateRangeID;
        fltr.report = searchTerms.report;
        fltr.acccountype = searchTerms.acunttype == 1000 ? "All":  searchTerms.acunttype;
        fltr.endDate = searchTerms.endDate;     
        fltr.statusTypeSelected = searchTerms.statusTypeSelected == 0? 0: searchTerms.statusTypeSelected;  
        
        if (value == 'SbSummary') {
            search.orderBy="modifiedDate";
            search.order= "desc";
            search.currentPage=1;
            search.pageSize = 10;
            handleSearch(fltr);
        }
        if (value == 'SbDetails' && fltr.report == "utilizationData") {
            if(rowdata){
                //filterObj.Accountype= rowdata;
                 let payload = cloneDeep(search);
                payload.Accountype = rowdata.accountType;
                 rrenderAccountTypeDetails(payload);
               }else{                
                 fetchUtilizationDetailsList(search);
               }
        }
        if (value == 'SbDetails' && fltr.report == "Drupspendbyaccount") {
            if(rowdata){
                //filterObj.Accountype= rowdata;
                 let payload = cloneDeep(search);
                payload.Accountype = rowdata.accountType;   
                payload.accuntNumer= rowdata.accuntNumer;
                payload.status = rowdata.poStatus;              
                rrenderdrugAccountTypeDetails(payload);
               }else{                
                fetchDrupspendbyaccountDetailsList(search);
            }
        }
    };

    const handleSearch = async (filter) => {
        debugger;
        const {
            accumulationIDs,
            coveredEntityIDs,
            startDate,
            dateRangeID,
            acccountype,
            report,
            statusTypeSelected,
            endDate,
        } = filter;
        setReportType(report);
        search.CeIdS = coveredEntityIDs;
        search.AccumulationIDs = accumulationIDs;
        search.StartDate = startDate;
        search.EndDate = endDate;
        search.DateRangeID = dateRangeID;
        search.Report = report;
        search.Accountype = acccountype;
        search.StatusTypeId = statusTypeSelected
        updateStates(sbreports);
        if (report == "utilizationData" || report =="utilizationerror") {
            await fetchUtilizationsummeryList(search);
        }
        if (report == "Drupspendbyaccount" || report=="Wacimpact") {
            await fetchDrupspendbyaccountsummeryList(search);
        }
        setKey('SbSummary');

    };
    const fetchUtilizationsummeryList = async (filters) => {
        debugger;
        try {
            const { data } = await API.post(`SBTenant/${orgId.tenantID}/Report/UtilizationSummeryAll/`, filters,
                { hasDefaultURL: true, }
            )
            if (data) {
                setSummeryData(data);
                // toggleSider();

            }
            else {
                setSummeryData([]);
            }

        }
        catch {

        }

    }
    const fetchUtilizationDetailsList = async (filters) => {
        debugger;
        try {
            const { data } = await API.post(`SBTenant/${orgId.tenantID}/Report/UtilizationDetialsReportsAll/`, filters,
                { hasDefaultURL: true, }
            )
            if (data?.items?.length > 0) {
                setDetailsData(data.items);
                setTotalItem(data.totalRecords);              
            }
            else {
                setDetailsData([]);
                setTotalItem(0);
            }

        }
        catch {
         console.log('Error');
        }

    }

    const rrenderdrugAccountTypeDetails = async (filters) => {
        debugger;
        try {
            const { data } = await API.post(`SBTenant/${orgId.tenantID}/Report/GetDrugAccountTypeHyperLink/`, filters,
                { hasDefaultURL: true, }
            )
           if (data?.items?.length > 0) {
               setDetailsData(data.items);
                setTotalItem(data.totalRecords);
            }
             else{
                setDetailsData([]);
                setTotalItem(0);

            }
        }
        catch {

        }
    }

    const fetchDrupspendbyaccountDetailsList = async (filters) => {
        debugger;
        try {
            const { data } = await API.post(`SBTenant/${orgId.tenantID}/Report/DrugSpendDetialsReportsAll/`, filters,
                { hasDefaultURL: true, }
            )
            if (data?.items?.length > 0) {
                setDetailsData(data.items);
                setTotalItem(data.totalRecords);               
            }
            else{
                setDetailsData([]);
                setTotalItem(0); 
            }
        }
        catch {
          console.log("Error");
        }

    }
    const fetchDrupspendbyaccountsummeryList = async (filters) => {
        debugger;
        try {
            const { data } = await API.post(`SBTenant/${orgId.tenantID}/Report/DrugSpendSummeryAll/`, filters,
                { hasDefaultURL: true, }
            )
            if (data?.length > 0) {
                setSummeryData(data);
            }
            else{
                setSummeryData([]);
            }

        }
        catch {
          console.log("Error");
        }

    }
     const rrenderAccountTypeDetails = async (rowData) => {
            debugger;
            //search.Accountype = rowData.accountType;
            try {
                const { data } = await API.post(`SBTenant/${orgId.tenantID}/Report/GetAccountTypeHyperLink/`, rowData,
                    { hasDefaultURL: true, }
                )
               if (data?.items?.length > 0) {
                    setDetailsData(data.items);
                    setTotalItem(data.totalRecords);
                }
                else{
                    setDetailsData([]);
                    setTotalItem(0);
                }
            }
            catch {
    
            }
    }

    const onDataChange = (data,rowData) => {
        debugger;
        setKey('SbDetails');
        setDetailsData(data.items);
        setTotalItem(data.totalRecords);
        setfullRowdata(null);
    }
    const Rowdata = (data) => {
        debugger;
        setRowdata(data);
        setfullRowdata(data);
    }
    const onDataChange1 = (data) => {
        debugger;
        setKey('SbDetails');
        if(data=="unmapped-chargecode"){
        setDetailsData(unmappeddata);
     setTotalItem(unmappeddata.length);
        }
        if(data=="location-pending"){
            setDetailsData(locationpending)
            setTotalItem(locationpending.length)
        }
        if(data=="patient-pending"){
            setDetailsData(patientpending)
            setTotalItem(patientpending.length)
        }
        if(data=="drugadministration"){
            setDetailsData(drugadministration)
            setTotalItem(drugadministration.length)
        }
        if(data=="dispensingqty"){
            setDetailsData(dispensingqty)
            setTotalItem(dispensingqty.length)
        }
        if(data=="grosscharge"){
            setDetailsData(grosscharge)
            setTotalItem(grosscharge.length)
        }
        if(data=="payor-exclude"){
            setDetailsData(payorexclude)
            setTotalItem(payorexclude.length)

        }
    }
    const refetch = () => {
        debugger;
        sbreports.search.currentPage=1;
        handleTabChange(key);
        setColumnFilters([]);
    };
    const handleSearchColumnFilters = async (columnFilters) => {
        debugger;
        const filterObj = cloneDeep(search);
        if (columnFilters && columnFilters.length > 0) {
            filterObj.filters = [...filterObj.filters, ...columnFilters];
            setColumnFilters(columnFilters);
        }
         sbreports.search.currentPage=1;
         filterObj.currentPage=1;
         
        if (key == 'SbSummary' && filterObj.Report == "utilizationData") {

            await fetchUtilizationsummeryList(filterObj);
        }
        if (key == 'SbSummary' && filterObj.Report == "Drupspendbyaccount") {

            await fetchDrupspendbyaccountsummeryList(filterObj);
        }
        if (key == 'SbDetails' && filterObj.Report == "utilizationData") {
            if(rowdata){
                filterObj.Accountype= rowdata.accountType;
                await rrenderAccountTypeDetails(filterObj);
               }else{
                await fetchUtilizationDetailsList(filterObj);
               }
        }
        if (key == 'SbDetails' && filterObj.Report == "Drupspendbyaccount") {
            if(rowdata){
                filterObj.Accountype= rowdata.accountType;
                filterObj.AccuntNumer= rowdata.accuntNumer;
                filterObj.status = rowdata.poStatus;
                await rrenderdrugAccountTypeDetails(filterObj);
               }else{
                await fetchDrupspendbyaccountDetailsList(filterObj);
               }
        }
    };
    const onPageChange = (filter, haveColFilter) => {
        debugger;
        updateUtilizationAndDrupSpendBySearch(filter);
        if (haveColFilter) {
            const filterObj = cloneDeep(search);
            filterObj.filters = [...filterObj.filters, ...filter.filters];

            sbreports.search = { ...sbreports.search };
            filterObj.Accountype = rowdata === "" ? "All" : rowdata.accountType;
           // fetchUtilizationDetailsList(filterObj);
            if (key == 'SbSummary' && filterObj.Report == "utilizationData") {
                 fetchUtilizationsummeryList(filterObj);
            }
            if (key == 'sbSummary' && filterObj.Report == "Drupspendbyaccount") {
                 fetchDrupspendbyaccountsummeryList(filterObj);
            }
            if (key == 'SbDetails' && filterObj.Report == "utilizationData") {             
                 fetchUtilizationDetailsList(filterObj);
            }
            if (key == 'SbDetails' && filterObj.Report == "Drupspendbyaccount") {
                 fetchDrupspendbyaccountDetailsList(filterObj);
            }
        } else {
            if (key == 'SbSummary' && filter.Report == "utilizationData") {
                 fetchUtilizationsummeryList(filter);
            }
            if (key == 'SbSummary' && filter.Report == "Drupspendbyaccount") {
                 fetchDrupspendbyaccountsummeryList(filter);
            }
            if (key == 'SbDetails' && filter.Report == "utilizationData") {
                if(rowdata || rowdata === null){
                    filter.Accountype =rowdata.accountType;
                    rrenderAccountTypeDetails(filter);
                }else{
                    fetchUtilizationDetailsList(filter);
                }
                 //fetchUtilizationDetailsList(filter);
            }
            if (key == 'SbDetails' && filter.Report == "Drupspendbyaccount") {
                if(rowdata || rowdata === null){
                    filter.Accountype= rowdata.accountType;
                    filter.accuntNumer= rowdata.accuntNumer;
                    filter.status = rowdata.poStatus;
                     rrenderdrugAccountTypeDetails(filter);
                   }else{
                     fetchDrupspendbyaccountDetailsList(filter);
                }
                 //fetchDrupspendbyaccountDetailsList(filter);
            }
            sbreports.search = { ...sbreports.search, ...filter };
        }
        setStates('sbreports', sbreports);
    };
    const updateUtilizationAndDrupSpendBySearch = (filter) => {
        sbreports.search.currentPage = filter.currentPage;
        sbreports.search.pageSize = filter.pageSize;
        sbreports.search.order = filter.order;
        sbreports.search.orderBy = filter.orderBy;
    }

    return (
        <div>
            <Container fluid className='width_info bin_info'>
            <div className={collapseSider ? "mb-0" : "mb-3"}>
                <Card className='border-0 shadow-top'>
                    <CardBody hidden={collapseSider} className=''>
                        <ErrorBoundary >
                            <SearchContainer orgId={orgId} onreset={onreset} onSearch={handleSearch} setDetailsData={setDetailsData} setSummeryData={setSummeryData}  setTotalItem={setTotalItem}/>
                        </ErrorBoundary>
                    </CardBody>
                    </Card>
                    </div>
                 <Card className='border-0 shadow-top '>
                    <CardBody>
                    {/* <Container fluid className='my-3 bin_info'> */}
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => onKeyChange(k)}
                            className="mb-3"
                        >
                            <Tab eventKey="SbSummary" title="Summary">
                                {/* <div className="py-2 text-center">
                                    <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                        <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                                    </span>
                                </div> */}
                                <ErrorBoundary>
                                    <SbSummaryTable
                                    key={key}
                                        reportType={reportType}
                                        summeryData={summeryData}
                                        orgId={orgId}
                                        search={search}
                                        filters={search}
                                        totalItem={totalItem}
                                        onDataChange={onDataChange}
                                        Rowdata={Rowdata}
                                        onDataChange1={onDataChange1}
                                        refetch={refetch}
                                        onSearchColumnFilters={handleSearchColumnFilters}
                                        onPageChange={onPageChange}
                                        collapseSider={collapseSider}
          toggleSider={toggleSider}
          pharmaData={pharmaData}
          resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                                    />
                                </ErrorBoundary>
                            </Tab>
                            <Tab eventKey="SbDetails" title="Details">
                                {/* <div className="py-2 text-center">
                                    <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                        <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                                    </span>
                                </div> */}
                                <ErrorBoundary>
                                    <SbDetailsTable
                                    key={key}
                                        detailsData={detailsData}
                                        reportType={reportType}
                                        totalItem={totalItem}
                                        search={search}                                        
                                        FullRowData= {fullRowdata}
                                        collapseSider={collapseSider}
                toggleSider={toggleSider}
                orgId={orgId}
                                        filters={search}
                                        refetch={refetch}
                                        onSearchColumnFilters={handleSearchColumnFilters}
                                        onPageChange={onPageChange}
                                        pharmaOrders={pharmaOrders}
                                        resetFilterFlag={resetFilterFlag}
                                        SetResetFilterFlag={SetResetFilterFlag}
                                    />
                                </ErrorBoundary>
                            </Tab>
                        </Tabs>
                        </CardBody>
                    {/* </Container> */}
                </Card>
            </Container>
            
            <ToastContainer position='top-right' autoClose={3000} />
        </div>
    );
};

export default SbReports;
